"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1002],{

/***/ 61002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ GetCurrentAffiliateSharedUseCase; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90581);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50853);
/* harmony import */ var _infrastructure_SharedRepositoryProxy__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76472);




var GetCurrentAffiliateSharedUseCase = /*#__PURE__*/ function() {
    "use strict";
    function GetCurrentAffiliateSharedUseCase(repository) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, GetCurrentAffiliateSharedUseCase);
        this.repository = repository;
    }
    var _proto = GetCurrentAffiliateSharedUseCase.prototype;
    _proto.execute = function execute() {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                return [
                    2,
                    _this.repository.affiliate()
                ];
            });
        })();
    };
    GetCurrentAffiliateSharedUseCase.create = function create(param) {
        var config = param.config, repository = param.repository;
        return new GetCurrentAffiliateSharedUseCase(repository !== null && repository !== void 0 ? repository : _infrastructure_SharedRepositoryProxy__WEBPACK_IMPORTED_MODULE_0__/* .SharedRepositoryProxy.create */ .B.create({
            config: config
        }));
    };
    return GetCurrentAffiliateSharedUseCase;
}();
GetCurrentAffiliateSharedUseCase.USE_CASE_NAME = "GetCurrentAffiliateSharedUseCase";



/***/ })

}]);